// @ts-check

import { Wishlist } from '@theme/lib-wishlist';
import { ThemeEvent } from '@theme/events';

/**
 * Sync wishlist count badge and heart icon state for a header wishlist root.
 * @param {HTMLElement} root
 */
function syncWishlistCountForRoot(root) {
  const wrapper = root.querySelector('[data-wishlist-wrapper]');
  const countElement = root.querySelector('[data-wishlist-count]');
  if (!(wrapper instanceof HTMLElement)) return;
  if (!(countElement instanceof HTMLElement)) return;

  const count = Wishlist.get().length;

  if (count === 0) {
    countElement.textContent = '';
    countElement.hidden = true;
    wrapper.setAttribute('data-count', '0');
  } else {
    countElement.textContent = String(count);
    countElement.hidden = false;
    wrapper.setAttribute('data-count', String(count));
  }

  const iconElement = countElement.previousElementSibling;
  if (!(iconElement instanceof HTMLElement)) return;

  iconElement.classList.toggle('not-wishlisted-items', count === 0);
  iconElement.classList.toggle('has-wishlisted-items', count > 0);
}

function initHeaderWishlistBlocks() {
  const roots = document.querySelectorAll('[data-header-wishlist]');
  roots.forEach((root) => {
    if (!(root instanceof HTMLElement)) return;
    syncWishlistCountForRoot(root);
  });
}

document.addEventListener('DOMContentLoaded', initHeaderWishlistBlocks);
document.addEventListener('shopify:section:load', initHeaderWishlistBlocks);
window.addEventListener(ThemeEvent.WishlistChanged, initHeaderWishlistBlocks);
window.addEventListener(ThemeEvent.WishlistRefresh, initHeaderWishlistBlocks);
